<div id="tab-content">
  <mat-table id="fleet-quantities" [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="seat">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="table-number"> {{ 'fleet.card.table.seat' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element" class="table-number"> {{ element.truckSpec.seat }} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="model">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="column-truck-model"> {{ 'fleet.card.table.model' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element" class="column-truck-model"> {{ element.truckSpec.specification }} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="realQty">
      <mat-header-cell *matHeaderCellDef class="table-number"> {{ 'fleet.card.table.quantity' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element" class="table-number tkc-number"> {{ element.truckStat.fleetQty }} </mat-cell>
    </ng-container>
    @for (monthNumber of monthsNumbersToDisplay; track monthNumber) {
      <ng-container matColumnDef="{{ monthNumber }}">
        <mat-header-cell *matHeaderCellDef class="table-number">
          <div class="month-header">
            <span>{{ 'common.months.' + monthNumber | translate }}</span>
            <span class="year">{{ getYearForMonth(monthNumber) }}</span>
          </div>
        </mat-header-cell>
        <mat-cell *matCellDef="let element;" [ngClass]="getMonthClass(monthNumber, element.fcsts[monthNumber]?.year)" class="table-number">
          @if (!element.fcsts[monthNumber]) {
            -
          } @else if (isEditableMonth(monthNumber, element.fcsts[monthNumber]?.year)) {
              <a class="fleet-qty" (click)="openCellModal(element, monthNumber)">
                {{ element.fcsts[monthNumber]?.fleetQty }}
                @if (element.fcsts[monthNumber]?.newFleetQty) {
                  + {{ element.fcsts[monthNumber]?.newFleetQty }}
                }
              </a>
          } @else {
              {{element.fcsts[monthNumber]?.fleetQty}}
              @if (element.fcsts[monthNumber]?.newFleetQty) {
                + {{element.fcsts[monthNumber]?.newFleetQty}}
              }
          }
        </mat-cell>
      </ng-container>
    }
    <ng-container matColumnDef="action">
      <mat-header-cell *matHeaderCellDef> {{ 'fleet.card.table.action' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element">
        @if (element.truckStat.fleetQty <= 0) {
          <button mat-icon-button class="color-warn mic-icon-button-large" (click)="deleteFleet(element)">
            <mat-icon class="color-warn">delete</mat-icon>
          </button>
        }
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: columns;"></mat-row>
  </mat-table>
  @if (dataSource.data.length === 0) {
    <tr id="no-data-row">
      @if (!isLoadingData()) {
        <td id="no-data-cell">
          <tkc-no-data />
        </td>
      } @else {
        <td id="no-data-cell">
        </td>
      }
    </tr>
  }
</div>
